import { render } from "./SatelitalInfo.component.vue?vue&type=template&id=5ce45e04&scoped=true&ts=true"
import script from "./SatelitalInfo.component.vue?vue&type=script&lang=ts"
export * from "./SatelitalInfo.component.vue?vue&type=script&lang=ts"

import "./SatelitalInfo.component.vue?vue&type=style&index=0&id=5ce45e04&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce45e04"]])

export default __exports__